import React from 'react';
import { ICONS } from 'Components/utils/icon/icons';
import { t } from 'Src/i18n';
import { useTracking } from 'Tracking/tracking-api/useTracking';
import { Button } from 'Components/frameworks/button/Button';
export const PriceLegend = ({
  canReset,
  durationLabel,
  onReset,
}: {
  canReset: boolean;
  durationLabel: string;
  onReset: () => void;
}) => {
  const track = useTracking();
  return (
    <div className="w-full p-20 md:px-0">
      <div className="flex items-center justify-between gap-10">
        <p className="text-16">
          {t('faceting.when.pricesBasedOn')}
          <strong data-testid="prices-duration-label">
            &nbsp;
            {durationLabel}
          </strong>
        </p>
        <Button
          data-testid="PriceLegend-calendarReset"
          iconLeft={{
            name: ICONS.RELOAD,
          }}
          isDisabled={!canReset}
          onClick={() => {
            onReset();
            track({
              actionGA: 'calendarPrice',
              categoryGA: 'resort',
              labelGA: 'resetCalendar',
            });
          }}
          size="small"
        >
          {t('booking.priceCalendar.resetCalendar')}
        </Button>
      </div>
      <ul className="mt-10 flex flex-wrap gap-15 font-bold">
        <li className="flex items-center gap-5 text-12 text-green sm:text-14">
          <span className="inline-block aspect-square h-[1em] rounded-full bg-current" />
          {t('faceting.when.bestPrice')}
        </li>
        <li className="flex items-center gap-5 text-12 text-orange sm:text-14">
          <span className="inline-block aspect-square h-[1em] rounded-full bg-current" />
          {t('faceting.when.lastAvailability')}
        </li>
        <li className="flex items-center gap-5 text-12 text-grey sm:text-14">
          <span className="inline-block aspect-square h-[1em] rounded-full bg-current" />
          {t('faceting.when.notAvailable')}
        </li>
      </ul>
    </div>
  );
};
